import { render, staticRenderFns } from "./manuscriptPage.vue?vue&type=template&id=6a76d2bc&scoped=true&"
import script from "./manuscriptPage.vue?vue&type=script&lang=js&"
export * from "./manuscriptPage.vue?vue&type=script&lang=js&"
import style0 from "./manuscriptPage.vue?vue&type=style&index=0&id=6a76d2bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76d2bc",
  null
  
)

export default component.exports